import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_ORGANIZATION_SUCCESS =
  "ORGANIZATION:UPSERT_ORGANIZATION_SUCCESS";

export const upsertOrganizationSuccessAction = (
  organizationKeyName?: OrganizationKeyName
) => ({
  type: UPSERT_ORGANIZATION_SUCCESS as typeof UPSERT_ORGANIZATION_SUCCESS,
  organizationKeyName,
});

export type UpsertOrganizationSuccessAction = ReturnType<
  typeof upsertOrganizationSuccessAction
>;
